import { createAction } from '@reduxjs/toolkit';
import { CurriculumSnapshot } from 'src/interfaces/curriculum';
import { Dispatch, RootState } from 'src/store';

export const replaceCurriculum =
  createAction<{ snapshot: CurriculumSnapshot; lessonIds: string[] }>(
    'curriculum/replace',
  );

export const syncCurriculum =
  (snapshot: CurriculumSnapshot) =>
  (dispatch: Dispatch, getState: () => RootState) => {
    const previous = Object.values(getState().model.class_topic.entities)
      .filter((lesson) => lesson?.class_id === snapshot.course.id)
      .map((lesson) => lesson!.id);
    dispatch(
      replaceCurriculum({
        snapshot,
        lessonIds: [
          ...previous,
          ...snapshot.lessons.map((lesson) => lesson.id),
        ],
      }),
    );
  };
